














import Vue from "vue";

import InputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";

export default Vue.extend({
    components: {
        InputNumber: InputNumber
    },
    data: function() {
        return {
            pathInStore: "property.land.totalBuildableGroundFloorSurface",
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE", "OFFICE", "INDUSTRY", "COMMERCIAL", "LAND", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        totalBuildableGroundFloorSurface: function(): string {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? "";
        },
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(totalBuildableGroundFloorSurface: number): void {
            if (totalBuildableGroundFloorSurface === 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": totalBuildableGroundFloorSurface});
            }
        }
    }
});
